import axios from 'axios';

import {
  ResponseObj,
  GestacaoFormData,
  GestacaoFinalizarFormData,
  GestacaoAnteriorFormData,
  GestacaoAlteraResponsavelFormData,
  GestacoesPaginatedData,
  GestacaoFinalizadaAlterarFormData,
} from '../../../back/src/types';
import { Gestacao } from '../../../back/src/entity/Gestacao';
import { MedicaoGlicemia } from '../../../back/src/entity/MedicaoGlicemia';
import { MedicaoPressaoArterial } from '../../../back/src/entity/MedicaoPressaoArterial';

const criaGestacao = async (
  formData: GestacaoFormData,
): Promise<ResponseObj<Gestacao>> => {
  const res = await axios.post<ResponseObj<Gestacao>>('gestacoes', formData);
  return res.data;
};

const criaGestacaoAnterior = async (
  formData: GestacaoAnteriorFormData,
): Promise<ResponseObj<Gestacao>> => {
  const res = await axios.post<ResponseObj<Gestacao>>('gestacoes/anterior', formData);
  return res.data;
};

const alteraGestacao = async (formData: GestacaoFormData): Promise<ResponseObj<Gestacao>> => {
  const res = await axios.put<ResponseObj<Gestacao>>('gestacoes', formData);
  return res.data;
};

const alteraGestacaoFinalizada = async (
  gestacaoId: number,
  formData: GestacaoFinalizadaAlterarFormData,
): Promise<ResponseObj<Gestacao>> => {
  const res = await axios.put<ResponseObj<Gestacao>>(`gestacoes/${gestacaoId}/alterar_finalizada`, formData);
  return res.data;
};

const finalizaGestacao = async (
  formData: GestacaoFinalizarFormData,
): Promise<ResponseObj<Gestacao>> => {
  const res = await axios.put<ResponseObj<Gestacao>>('gestacoes/finalizar', formData);
  return res.data;
};

const removeGestacao = async (
  gestacaoId: number,
): Promise<ResponseObj<Boolean>> => {
  const res = await axios.delete<ResponseObj<Boolean>>(`gestacoes/${gestacaoId}`);
  return res.data;
};

const medicoesGlicemia = async (
  gestacaoId: number,
): Promise<ResponseObj<MedicaoGlicemia[]>> => {
  const res = await axios.get<ResponseObj<MedicaoGlicemia[]>>(`gestacoes/${gestacaoId}/medicoes_glicemia`);
  return res.data;
};

const medicoesPressaoArterial = async (
  gestacaoId: number,
): Promise<ResponseObj<MedicaoPressaoArterial[]>> => {
  const res = await axios.get<ResponseObj<MedicaoPressaoArterial[]>>(`gestacoes/${gestacaoId}/medicoes_pressao_arterial`);
  return res.data;
};

const alteraResponsavel = async (
  formData: GestacaoAlteraResponsavelFormData,
): Promise<ResponseObj<null>> => {
  const res = await axios.post<ResponseObj<null>>('gestacoes/alterar_responsavel', formData);
  return res.data;
};

const buscaGestacoesFinalizadas = async (
  queryObj: Object = {},
): Promise<ResponseObj<GestacoesPaginatedData>> => {
  const res = await axios.get<ResponseObj<GestacoesPaginatedData>>('gestacoes/finalizadas', {
    params: queryObj,
  });
  return res.data;
};

const geraPlanilhaNascidos = async (queryObj: Object = {}) => {
  const res = await axios.get('gestacoes/planilha_nascidos', {
    params: queryObj,
  });
  return res.data;
};

export default {
  alteraGestacao,
  alteraGestacaoFinalizada,
  alteraResponsavel,
  buscaGestacoesFinalizadas,
  criaGestacao,
  criaGestacaoAnterior,
  finalizaGestacao,
  geraPlanilhaNascidos,
  medicoesGlicemia,
  medicoesPressaoArterial,
  removeGestacao,
};
